"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var date_fns_1 = require("date-fns");
var react_final_form_1 = require("react-final-form");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var OutlinedToggleOptions_1 = __importDefault(require("shared/components/Form/OutlinedToggleOptions"));
var Text_1 = __importDefault(require("shared/components/Text"));
var backend_1 = require("utils/backend");
var fieldProcessors_1 = require("utils/fieldProcessors");
var firebaseConf_1 = require("utils/firebaseConf");
var FetchAttachmentsModal_1 = __importDefault(require("../styles/FetchAttachmentsModal"));
var DateRangeField_1 = __importDefault(require("./DateRangeField"));
var storageRef = firebaseConf_1.storage.ref();
var DURATIONS = ['1Y', '6M', '3M', '1M'];
var DURATION_MAPPER = {
    '1Y': { years: 1 }, '6M': { months: 6 }, '3M': { months: 3 }, '1M': { months: 1 },
};
var DIVIDER = '_-_';
var durationOptions = DURATIONS.map(function (d) { return ({
    value: "".concat((0, date_fns_1.sub)(new Date(), DURATION_MAPPER[d]).toJSON()).concat(DIVIDER).concat(new Date().toJSON()),
    label: "Last ".concat(d),
}); });
var FetchAttachments = function (_a) {
    var close = _a.close, company = _a.company;
    var _b = __read((0, backend_1.useCall)('transactions-fetchAttachmentsCall', { companyId: company.id }), 1), fetchAttachments = _b[0];
    var _c = __read((0, backend_1.useCall)('transactions-downloadAttachments', { companyId: company.id }), 1), downloadAttachments = _c[0];
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var timeRange, result, downloadUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    timeRange = values.timeRange || { start: (0, date_fns_1.sub)(new Date(), DURATION_MAPPER[values.duration]) };
                    if (!!values.isDownload) return [3 /*break*/, 1];
                    fetchAttachments({ timeRange: timeRange })();
                    return [3 /*break*/, 4];
                case 1: return [4 /*yield*/, downloadAttachments({ timeRange: timeRange })()];
                case 2:
                    result = _a.sent();
                    if (!result)
                        return [2 /*return*/];
                    return [4 /*yield*/, storageRef.child(result.data.filePath).getDownloadURL()];
                case 3:
                    downloadUrl = _a.sent();
                    (0, fieldProcessors_1.download)(downloadUrl, "attachments_".concat(new Date().toJSON(), ".zip"));
                    _a.label = 4;
                case 4:
                    close();
                    return [2 /*return*/];
            }
        });
    }); };
    var initialValues = {};
    var submitterIsDownload = function (isDownload, form, handleSubmit) { return function () {
        form.change('isDownload', isDownload);
        handleSubmit();
    }; };
    return ((0, jsx_runtime_1.jsx)(FetchAttachmentsModal_1.default, __assign({ open: true, onClose: close, label: "fetch-attachments-modal" }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit, subscription: { submitting: true, valid: true }, initialValues: initialValues, validate: function (v) { return (!v.timeRange && !v.duration) ? { timeRange: 'Error' } : undefined; } }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit, form = _a.form, submitting = _a.submitting, valid = _a.valid;
                return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, py: 2, px: 4 }, { children: (0, jsx_runtime_1.jsxs)("strong", { children: ["Fetch attachments for ", company.name] }) })), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ py: 2, px: 4, borderTop: "1px solid #EDF1F3", borderBottom: "1px solid #EDF1F3" }, { children: [(0, jsx_runtime_1.jsx)(DateRangeField_1.default, { name: "timeRange", submitting: submitting }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: OutlinedToggleOptions_1.default, name: "timeRange", options: durationOptions, parse: function (v) { return ({ start: v === null || v === void 0 ? void 0 : v.split(DIVIDER)[0], end: v === null || v === void 0 ? void 0 : v.split(DIVIDER)[1] }); }, format: function (v) { return v && "".concat(v.start).concat(DIVIDER).concat(v.end); } })] })), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center", justifyContent: "center", p: 2 }, { children: [(0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ disabled: submitting || !valid, onClick: submitterIsDownload(true, form, handleSubmit), sx: { mr: 1 } }, { children: "Download invoices" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ disabled: submitting || !valid, onClick: submitterIsDownload(false, form, handleSubmit) }, { children: "Fetch invoices" }))] }))] })));
            } })) })));
};
exports.default = FetchAttachments;
